import React, { ReactNode } from 'react';
import { Skeleton } from 'antd';
import { SkeletonImageProps as SkeletonImageCopyProps } from 'antd/lib/skeleton/Image';

export type SkeletonImageProps = SkeletonImageCopyProps & {
  children?: ReactNode;
};

const ProSkeletonImage: React.FC<SkeletonImageProps> = React.forwardRef<
  any,
  SkeletonImageProps
>((props, ref) => {
  const { children, ...resProps } = props;

  return <Skeleton.Image {...resProps}>{children}</Skeleton.Image>;
});

export default ProSkeletonImage;
